import { render, staticRenderFns } from "./TableFabric.vue?vue&type=template&id=00ca942c&scoped=true&"
import script from "./TableFabric.vue?vue&type=script&lang=js&"
export * from "./TableFabric.vue?vue&type=script&lang=js&"
import style0 from "./TableFabric.vue?vue&type=style&index=0&id=00ca942c&scoped=true&lang=css&"
import style1 from "./TableFabric.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ca942c",
  null
  
)

export default component.exports